import { ProjectSelectionCount, ProjectSelectionLineInput, ProjectSelectionMode } from '../api';

export const getProjectSelectionConfig = (orderPage: any) => orderPage?.project_selection_config;

export const isProjectSelectionInBooking = (orderPage: any): boolean => {
  const mode = getProjectSelectionConfig(orderPage)?.mode;
  return mode === ProjectSelectionMode.IN_BOOKING_OPTIONAL || mode === ProjectSelectionMode.IN_BOOKING_REQUIRED;
};

export const isProjectSelectionPostPayment = (orderPage: any): boolean =>
  getProjectSelectionConfig(orderPage)?.mode === ProjectSelectionMode.POST_PAYMENT;

export const getRequiredProjectQuantity = (
  selectionCount: ProjectSelectionCount | undefined,
  persons: number,
): number => (selectionCount === ProjectSelectionCount.PER_PARTICIPANT ? Math.max(persons, 1) : 1);

export const getSelectedProjectQuantity = (selection: ProjectSelectionLineInput[]): number =>
  selection.reduce((total, line) => total + (line.quantity || 0), 0);
